export default __webpack_public_path__ + "static/media/65.2a85228b.jpg";